import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-6 md:p-8 lg:p-10 text-center lg:text-left">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3">{appData.title}</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">{appData.desc}</p>
              <div className="grid grid-cols-2 gap-2 mb-6">
                {appData.features.map((f) => (
                  <div key={f} className="flex items-center gap-2 text-sm text-foreground-700">
                    <div className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-primary-600 text-xs"></i>
                    </div>
                    {f}
                  </div>
                ))}
              </div>
              <a href="#carousel" className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-medium text-sm rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-download-2-line"></i>
                了解更多
              </a>
            </div>
            <div className="flex-1 p-6 md:p-8 lg:p-10 flex justify-center">
              <div className="w-48 md:w-56 lg:w-64 aspect-[3/4] rounded-2xl overflow-hidden">
                <img
                  src={appData.image}
                  alt="91麻豆免费视频网站APP"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}